export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q04_a.cd5843cb.png";